import { getEnv } from '@luna/env';
import type { GeorgeJQueryXHR } from '@shared/core-types';

import { AjaxErrorDetail } from './AjaxErrorDetail';

const OPTIONS_CALL_FAILED_STATUS = -100;
const REPORTED_URL_MAX_LENGTH = 250;

function getNormalizedURL(url = ''): string {
    const { prestoUrl, georgeApiUrl, beanCounterUrl } = getEnv();
    return url
        .replace(prestoUrl, '')
        .replace(georgeApiUrl, '')
        .replace(beanCounterUrl, '')
        .substr(0, REPORTED_URL_MAX_LENGTH);
}

export class AjaxErrorDetailFactory {
    public static create(ajaxSettings: JQueryAjaxSettings, xhr: GeorgeJQueryXHR): AjaxErrorDetail {
        const url = getNormalizedURL(ajaxSettings.url);
        const method = ajaxSettings.type ?? '';
        const status = xhr.status ?? OPTIONS_CALL_FAILED_STATUS;
        const roundTrip = xhr.roundTrip ?? 0;
        const requestId = xhr.requestId ?? '';

        return new AjaxErrorDetail(url, method, status, roundTrip, requestId);
    }
}
